import { render } from "./CustomerJobs.vue?vue&type=template&id=72146990"
import script from "./CustomerJobs.vue?vue&type=script&lang=js"
export * from "./CustomerJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__